import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import { Link } from 'react-router-dom';

import { getRoles, setFilters, setPagination } from 'roles/actions';

import * as Common from 'common/components';

import RolesListHeader from 'roles/components/RolesListHeader';
import RolesFilters from 'roles/components/RolesFilters';
import RolesTable from 'roles/components/RolesTable';
import RoleRowContainer from 'roles/containers/RoleRowContainer';
import PropTypes from 'prop-types';

import {
  getVisibleRoles,
  getFilters,
  getPagination,
  getIsLoading,
  getNeedFetch,
} from 'roles/selectors';
import { getPermissions, getCompany } from 'auth/selectors';
import { valueFromEvent } from 'lib/util';
import { toggleRole } from 'roles/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

class RoleListContainer extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };
  state = {
    columnSearch: [
      // Cambiar por redux
      { key: 'name', name: this.props.t('roles.searchEditor.name'), search: true },
    ],
  };

  handleToggleSearch = (col) => {
    let columnsNuevo = this.state.columnSearch;
    let datos = columnsNuevo.find((column) => column.key == col);
    datos.search = !datos.search;
    this.setState({ columnSearch: columnsNuevo });
    let columnsSearch = [];
    columnsNuevo.forEach((e) => {
      if (e.search) {
        columnsSearch.push(e.key);
      }
    });
    this.props.setFilters({ columnSearch: columnsSearch }); // Agregado a Redux
  };
  componentWillMount = () => this.fetch(this.props.filters, this.props.pagination);

  componentWillReceiveProps = (nextProps) =>
    nextProps.needFetch && this.fetch(nextProps.filters, nextProps.pagination);

  fetch = (filters, pagination) =>
    this.props.getRoles(
      this.props.company.id,
      filters,
      pagination.limit,
      pagination.page,
      pagination.orderBy,
      pagination.order
    );

  fetchDebounced = debounce(this.fetch, 100);

  handleSubmit = () => this.fetch(this.props.filters, this.props.pagination);

  handleValueChange = (e) => this.props.setFilters(valueFromEvent(e));

  handleOrderChange = (orderBy, order) => this.props.setPagination({ orderBy, order });

  handleLimitChange = (limit) => this.props.setPagination({ limit });

  handlePageChange = (page) => this.props.setPagination({ page });

  handleToggle = (id) =>
    this.props
      .toggleRole(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));

  render() {
    const { t, match, roles, pagination, filters } = this.props;

    return (
      <Common.PageWrapper fluid={true}>
        {/* <RolesListHeader
          companyId={match.params.id}
          canAdd={this.props.permissions["acl.roles.add"] || false}
        /> */}
        <div className="col-12">
          <Common.Portlet
            title={t('menu.control_panel') + ' > ' + t('roles.subtitle')}
            icon={'shield'}
            button={
              <div className="btn-group pull-right">
                <Link to={`/companies/${match.params.id}/roles/add`} className="btn btn-info">
                  {t('actions.add')}
                </Link>
              </div>
            }
            buttonTwo={
              <RolesFilters
                handleSubmit={this.handleSubmit}
                handleToggleSearch={this.handleToggleSearch}
                columnSearch={this.state.columnSearch}
                handleValueChange={this.handleValueChange}
                values={filters}
              />
            }
          >
            <RolesTable
              order={pagination.order}
              orderBy={pagination.orderBy}
              handleToggle={this.handleToggle}
              company={this.props.company}
              permissions={this.props.permissions}
              handleOrderChange={this.handleOrderChange}
              isLoading={this.props.isLoading}
              count={this.props.roles.length}
            >
              {roles.map((role) => (
                <RoleRowContainer key={role.id} role={role} handleToggle={this.handleToggle} />
              ))}
            </RolesTable>
            <Common.Pagination
              {...pagination}
              handleLimitChange={this.handleLimitChange}
              handlePageChange={this.handlePageChange}
            />
          </Common.Portlet>
        </div>
      </Common.PageWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  filters: getFilters(state),
  isLoading: getIsLoading(state),
  pagination: getPagination(state),
  roles: getVisibleRoles(state),
  needFetch: getNeedFetch(state),
  permissions: getPermissions(state),
  company: getCompany(state),
});

const mapDispatchToProps = {
  getRoles,
  setFilters,
  setPagination,
  toggleRole,
  error,
  success,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
  withRouter
)(RoleListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/containers/RolesListContainer.js